import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { LeadViewTimelineStepIcon } from "./lead-view-timeline-step-icon";
import { LeadViewTimelineProps } from "./lead-view-timeline.props";
import { QontoConnector } from "./lead-view-timeline.constant";
import "./lead-view-timeline.scss";
import { getLeadDetails } from "../../../../api/lead";
import { formatDateTime } from "../../../../utils/utils";

const LeadViewTimeline: React.FC<LeadViewTimelineProps> = (props: any) => {
  const { selectedLeadId, setLoading, setUpdatedDate, setAlertMessage,  setAlertType, setAlertOpen} = props;
  const [historyDetails, setHistoryDetails] = useState<any>(null);

  const handleEditOpen = () => {};
  const fetchLeadDetails = async () => {
    setLoading(true);
    try {
      const response = await getLeadDetails(selectedLeadId);
      setHistoryDetails(response?.data?.data?.leadHistories || []);
      setTimeout(() => setLoading(false), 1000);
      setUpdatedDate(formatDateTime(response?.data?.data?.updated_at))
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeadDetails();
  }, [selectedLeadId]);

  const formatFieldName = (fieldName: string): string => {
    const fieldMap: Record<string, string> = {
      first_name: "First Name",
      last_name: "Last Name",
      company: "Company",
      lead_owner: "Lead Owner",
      description: "Description",
      fax_number: "Fax",
      industry: "Industry",
      interested_products: "Interested Products",
      lead_source: "Lead Source",
      lead_status: "Lead Status",
      number_of_employees: "No of employees",
      primary_email_address: "Email",
      primary_phone_number: "Primary Phone Number",
      rating: "Confidence Score",
      secondary_email_addres: "Secondary Email",
      secondary_phone_number: "Secondary Phone Number",
      social_lead_id: "Social Lead Id",
      title: "Title",
      website_url: "Website",
      street:"Street",
      city:"City",
      state:"State",
      country:"Country",
      zipcode:"Zipcode",
      age: "Age",
      marital_status: "Marital Status",
      designation: "Designation",
      lead_value: "Lead Value",
      secondary_email_address: "Secondary Email",
      confidence_score: "Confidence Score",
      middle_name: "Middle Name",
      street_line_2: "Street Line 2",
      street_line_1: "Street Line 1",
      //Tasks and meetings
      start_date: "Start Date",
      status: "Status",
      type: "Campaign Type",
      preferred_contact_mode: "Preferred Contact Mode",
      location: "Location",
      meetStartTime: "From Date and Time",
      meetEndTime: "To Date and Time",
      host_id: "Host",
      participants: "Participants",
      related_to: "Related To",
      subject: "Subject",
      due_date: "Due Date",
      priority: "Priority",
      task_status: "Task Status",
      reminder: "Reminder",
      owner: "Owner",
      closed_time: "Closed Time",
      all_day: "All Day",
      // New call-related fields
      call_owner_id: "Call Owner",
      related_to_campaign_id: "Related To Campaign",
      related_to_lead_id: "Related To Lead",
      outgoing_call_status: "Outgoing Call Status",
      call_start_time: "Call Start Time",
      call_purpose: "Call Purpose",
      call_agenda: "Call Agenda",
      notes: "Notes",
      call_duration: "Call Duration",
      call_results: "Call Results",
      call_type: "Call Type",
      callFor: "Call For",
      owner_id: "Lead Owner",
      cancel_notes: "Cancel Notes",
    };

    return fieldMap[fieldName] || fieldName;
  };
  const renderFormattedDescription = (description: string) => {
    const parts = description.split(/(<b>.*?<\/b>)/g);

    return parts.map((part, index) => {
      if (part.startsWith("<b>") && part.endsWith("</b>")) {
        return <b key={index}>{part.substring(3, part.length - 4)}</b>;
      }
      return <span key={index}>{part}</span>;
    });
  };
  const groupByDate = (
    histories: any[]
  ): Record<string, { label: string; date: string }[]> => {
    return histories.reduce(
      (acc, history) => {
        const date = new Date(history.created_at).toLocaleDateString();
        if (!acc[date]) {
          acc[date] = [];
        }

        const createdBy = history.createdBy
          ? `- By ${history.createdBy.first_name} ${history.createdBy.last_name}`
          : "";
        acc[date].push({
          label: (
            <span>
              <span>
                <b>{formatFieldName(history.field_name)}{" "}</b>{renderFormattedDescription(history.description)}{" "}
              </span>
              <span className="lead-list-view-timeline-info-bar-box-steps-sub">
                {" "}
                {createdBy}
              </span>
            </span>
          ),
          date: formatDateTime(history.created_at),
        });

        return acc;
      },
      {} as Record<string, { label: string; date: string }[]>
    );
  };

  const steps: Record<string, { label: string; date: string }[]> =
    historyDetails ? groupByDate(historyDetails) : {};

  return (
    <div className="lead-list-view-timeline-info">
      <div className="lead-list-view-timeline-info-header">
        <div className="lead-list-view-timeline-info-header-text">Timeline</div>
      </div>
      {Object.entries(steps).map(([date, stepData], index) => (
        <div className="lead-list-view-timeline-info-bar-box" key={index}>
          <div className="lead-list-view-timeline-info-bar-box-date">
            {date}
          </div>
          <div className="lead-list-view-timeline-info-bar-box-steps">
            <Box sx={{ width: "100%" }}>
              <Stepper
                activeStep={stepData.length}
                connector={<QontoConnector />}
                orientation="vertical"
                sx={{ gap: 0, p: 0, m: 0 }}
              >
                {stepData.map((data, idx) => (
                  <Step key={idx}>
                    <StepLabel StepIconComponent={LeadViewTimelineStepIcon}>
                      <div className="lead-list-view-timeline-info-bar-box-steps-main-sub">
                        <div className="lead-list-view-timeline-info-bar-box-steps-main">
                          {data.label}
                        </div>
                        <div className="lead-list-view-timeline-info-bar-box-steps-sub">
                          {data.date}
                        </div>
                      </div>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeadViewTimeline;
